(() => {
  const configEl = document.getElementById('gtm-tracking-config');
  const config = configEl ? JSON.parse(configEl.textContent || '{}') : {};
  const currency = config.currency || 'EUR';
  const seenScroll = {};
  let lastPromotionState = null;
  let quizCompleteSent = false;

  function dataLayer() {
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
  }

  function publish(name, payload) {
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(name, payload || {});
    }
  }

  function sendGa4(name, params) {
    if (name === 'page_view' || name === 'page_viewed') return;
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params || {});
    }
  }

  function pushEvent(name, payload) {
    const event = Object.assign({ event: name }, payload || {});
    dataLayer().push(event);
    publish(name, payload || {});
    sendGa4(name, payload || {});
  }

  function pushEcommerce(name, ecommerce) {
    dataLayer().push({ ecommerce: null });
    dataLayer().push({ event: name, ecommerce: ecommerce });
    publish(name, ecommerce || {});
    sendGa4(name, ecommerce || {});
  }

  function moneyFromCents(value) {
    const amount = Number(value);
    if (Number.isNaN(amount)) return 0;
    return Math.round(amount) / 100;
  }

  function itemsFromCart(cart) {
    return (cart.items || []).map(function (item, index) {
      return {
        item_id: String(item.sku || item.variant_id || item.id),
        item_name: item.product_title || item.title,
        item_brand: item.vendor || 'Clairière',
        item_variant: item.variant_title || undefined,
        price: moneyFromCents(item.final_price || item.price),
        quantity: item.quantity,
        index: index + 1,
      };
    });
  }

  function cartValue(cart) {
    return moneyFromCents(cart.total_price);
  }

  async function fetchCart() {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) return null;
    return response.json();
  }

  function pushPageView() {
    pushEvent('page_view', {
      page_location: config.pageLocation || window.location.href,
      page_title: config.pageTitle || document.title,
      page_type: config.pageType || '',
    });
  }

  function pushViewItem() {
    if (!config.product) return;
    pushEcommerce('view_item', {
      currency: currency,
      value: config.product.price,
      items: [config.product],
    });
  }

  function pushViewItemList() {
    if (!config.collection || !config.collection.items || !config.collection.items.length) return;
    pushEcommerce('view_item_list', {
      item_list_id: String(config.collection.item_list_id || ''),
      item_list_name: config.collection.item_list_name || '',
      items: config.collection.items,
    });
  }

  function pushSearch() {
    const term = config.searchTerm || new URLSearchParams(window.location.search).get('q');
    if (!term) return;
    if (config.pageType === 'search' || config.template === 'search') {
      pushEvent('search', { search_term: term });
    }
  }

  function textOf(el) {
    return (el && el.textContent ? el.textContent : '').replace(/\s+/g, ' ').trim();
  }

  function closestLink(target) {
    return target && target.closest ? target.closest('a') : null;
  }

  document.addEventListener('shopify:cart:lines-update', function (event) {
    const action = event.detail && event.detail.action;
    const wait = event.detail && event.detail.promise ? event.detail.promise : Promise.resolve();
    wait
      .then(function () {
        return fetchCart();
      })
      .then(function (cart) {
        if (!cart) return;
        const ecommerce = {
          currency: currency,
          value: cartValue(cart),
          items: itemsFromCart(cart),
        };
        if (action === 'add') pushEcommerce('add_to_cart', ecommerce);
        if (action === 'remove') pushEcommerce('remove_from_cart', ecommerce);
        trackFreeShipping(cart);
      })
      .catch(function () {});
  });

  function bindCartDrawer() {
    const drawer = document.querySelector('theme-drawer#cart-drawer');
    if (!drawer) return;
    drawer.addEventListener('theme-drawer:open', function () {
      fetchCart()
        .then(function (cart) {
          if (!cart) {
            pushEvent('view_cart');
            return;
          }
          pushEcommerce('view_cart', {
            currency: currency,
            value: cartValue(cart),
            items: itemsFromCart(cart),
          });
          trackFreeShipping(cart);
        })
        .catch(function () {
          pushEvent('view_cart');
        });
    });
  }

  function trackFreeShipping(cart) {
    const bar = document.querySelector('.cart-fsb');
    if (!bar) return;
    const unlocked = bar.classList.contains('cart-fsb--unlocked');
    const state = unlocked ? 'unlocked' : 'locked';
    if (lastPromotionState === state) return;
    lastPromotionState = state;
    pushEvent('view_promotion', {
      promotion_id: 'free_shipping',
      promotion_name: 'Livraison offerte',
      creative_name: unlocked ? 'unlocked' : 'progress',
      threshold: config.freeShippingThreshold,
      cart_value: cart ? cartValue(cart) : undefined,
    });
  }

  document.addEventListener('click', function (event) {
    const checkout = event.target.closest('#checkout, .cart__checkout-button, button[name="checkout"]');
    if (checkout) {
      fetchCart()
        .then(function (cart) {
          pushEcommerce('begin_checkout', {
            currency: currency,
            value: cart ? cartValue(cart) : 0,
            items: cart ? itemsFromCart(cart) : [],
          });
        })
        .catch(function () {
          pushEvent('begin_checkout');
        });
      return;
    }

    const buy = event.target.closest('a[href="#kalme-buy"], a[href*="#kalme-buy"]');
    if (buy) {
      pushEvent('cta_buy', { cta_text: textOf(buy), cta_id: 'kalme-buy' });
      return;
    }

    const sticky = event.target.closest('.kalme-stickybar__submit, [data-kalme-stickybar] button[name="add"]');
    if (sticky) {
      pushEvent('sticky_cta_click', { cta_text: textOf(sticky) });
      return;
    }

    const try30 = event.target.closest('.kalme-loss__guarantee .kalme-btn--ghost');
    if (try30) {
      pushEvent('cta_buy', { cta_text: textOf(try30), cta_id: 'essayer_30_jours' });
      return;
    }

    const discover = event.target.closest(
      '.kalme-hero__actions .kalme-btn--primary, .kalme-promise__cta, .kalme-journey__cta'
    );
    if (discover) {
      pushEvent('cta_discover_games', { cta_text: textOf(discover), cta_href: discover.getAttribute('href') });
      return;
    }

    const findGame = event.target.closest(
      '.kalme-hero__actions .kalme-btn--ghost, .kalme-cta__actions .kalme-btn--ghost'
    );
    if (findGame) {
      pushEvent('cta_find_game', { cta_text: textOf(findGame), cta_href: findGame.getAttribute('href') });
      return;
    }

    const promo = event.target.closest('.cart-fsb');
    if (promo) {
      pushEvent('select_promotion', {
        promotion_id: 'free_shipping',
        promotion_name: 'Livraison offerte',
      });
      return;
    }

    const outbound = closestLink(event.target);
    if (outbound && outbound.hostname && outbound.hostname !== window.location.hostname) {
      const href = outbound.href;
      let org = 'other';
      if (href.indexOf('unicef') !== -1) org = 'UNICEF';
      else if (href.indexOf('who.int') !== -1) org = 'OMS';
      else if (href.indexOf('aap.org') !== -1) org = 'AAP';
      pushEvent('outbound_click', {
        link_url: href,
        link_text: textOf(outbound),
        outbound_org: org,
      });
    }
  });

  document.addEventListener('change', function (event) {
    const age = event.target.closest('[data-kalme-guide] input[name="age"]');
    if (age) {
      pushEvent('select_age', { age: age.value });
    }
  });

  function bindQuizComplete() {
    const guide = document.querySelector('[data-kalme-guide]');
    const cta = guide && guide.querySelector('[data-guide-cta]');
    if (!cta) return;
    const send = function () {
      if (quizCompleteSent || cta.hidden) return;
      quizCompleteSent = true;
      pushEvent('quiz_complete', {
        age: guide.querySelector('input[name="age"]:checked')?.value,
        interest: guide.querySelector('input[name="interest"]:checked')?.value,
        recommendation_title: textOf(guide.querySelector('[data-guide-result-title]')),
        recommendation_url: cta.getAttribute('href'),
      });
    };
    if (!cta.hidden) send();
    new MutationObserver(send).observe(cta, { attributes: true, attributeFilter: ['hidden'] });
  }

  document.addEventListener(
    'toggle',
    function (event) {
      const item = event.target.closest('.kalme-faq__item, .kalme-pdp__faq-item, .kalme-sources__details, .kalme-science__details');
      if (!item || !item.open) return;
      pushEvent('faq_open', {
        faq_question: textOf(item.querySelector('summary')),
      });
    },
    true
  );

  document.addEventListener('submit', function (event) {
    if (event.target.closest('form.email-signup__form')) {
      pushEvent('generate_lead', { lead_type: 'newsletter' });
      return;
    }
    if (event.target.closest('form.contact-form__form')) {
      pushEvent('contact_submit', { form_name: 'contact' });
      return;
    }
    const searchForm = event.target.closest('form.predictive-search-form, form.search-page-input__parent');
    if (searchForm) {
      const input = searchForm.querySelector('input[name="q"]');
      const term = input && input.value ? input.value.trim() : '';
      if (term) pushEvent('search', { search_term: term });
    }
  });

  document.addEventListener('visitorConsentCollected', function () {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    pushEvent('consent_update', {
      analytics_storage: privacy && privacy.analyticsProcessingAllowed() ? 'granted' : 'denied',
      ad_storage: privacy && privacy.marketingAllowed() ? 'granted' : 'denied',
    });
  });

  function bindScrollDepth() {
    const marks = [25, 50, 75, 100];
    const onScroll = function () {
      const doc = document.documentElement;
      const body = document.body;
      const height = Math.max(doc.scrollHeight, body.scrollHeight) - window.innerHeight;
      if (height <= 0) return;
      const percent = Math.round((window.scrollY / height) * 100);
      marks.forEach(function (mark) {
        if (percent >= mark && !seenScroll[mark]) {
          seenScroll[mark] = true;
          pushEvent('scroll_depth', { percent: mark });
        }
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  pushPageView();
  pushViewItem();
  pushViewItemList();
  pushSearch();
  bindCartDrawer();
  bindQuizComplete();
  bindScrollDepth();
})();
